/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from 'assets/theme-dark/base/colors';

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: 'smooth'
  },
  body: {
    minHeight: '100vh',
    backgroundColor: '#0e1628',
    backgroundImage:
      'radial-gradient(circle at 10% 10%, rgba(90,163,255,0.16), transparent 36%), radial-gradient(circle at 92% 0%, rgba(255,79,105,0.12), transparent 28%)',
    color: '#d3ddf5'
  },
  '#root': {
    minHeight: '100vh'
  },
  '*, *::before, *::after': {
    margin: 0,
    padding: 0,
    boxSizing: 'border-box'
  },
  '::selection': {
    backgroundColor: 'rgba(90, 163, 255, 0.25)',
    color: '#eff5ff'
  },
  'a, a:link, a:visited': {
    textDecoration: 'none !important'
  },
  'a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited': {
    color: `${dark.main} !important`,
    transition: 'color 150ms ease-in !important'
  },
  'a.link:hover, .link:hover, a.link:focus, .link:focus': {
    color: `${info.main} !important`
  }
};

export default globals;
